define('modules/form/input_view',[
  'backbone',
  'jquery',
  '_',

  './form_item_view',

  'text!./input_template.html',
  'text!modules/form/media_fact_connection/media_fact_connection_template.html'
], function (Backbone, $, _,
             FormItemView,
             template,
             media_fact_connection_template) {
  'use strict';
  var View = FormItemView.extend({
    initialize: function (options) {
      _.extend(this, options);

      this.listenTo(this.model, 'change', this.renderMediaFactConnection);

      FormItemView.prototype.initialize.apply(this, options);

      var value = {};
      value[this.model.get('name')] = this.model.get('value');

      this.dataModel.set(value);
      this.dataModelAttributesOriginal = _.cloneDeep(this.dataModel.attributes);

      this.render();
      this.renderMediaFactConnection();
    },
    media_fact_connection_template: _.template(media_fact_connection_template),
    events: {
      'change input': 'handleChange'
    },

    handleChange: function (e) {
      var property = this.model.get('name');

      this.dataModel.set(property, $(e.target).val());

      if (this.model.get('media_fact_connection') === 'Connected') {
        this.model.set('media_fact_connection', 'WillDisconnect');
      }
      // Reset to 'Connected' if user changes back to the original value.
      else if (this.model.get('media_fact_connection') === 'WillDisconnect'
        && (($(e.target).val() === this.dataModelAttributesOriginal[property]) || ($(e.target).val() === '' && !this.dataModelAttributesOriginal[property]))) {
        this.model.set('media_fact_connection', 'Connected');
      }
    },

    template: _.template(template),

    renderMediaFactConnection: function () {
      this.$('.js-media-fact-connection').html(this.media_fact_connection_template(this.model.attributes));
      return this;
    },

    render: function () {
      this.$el.html(this.template(this.model.toJSON()));
      return this;
    }
  });
  return View;
});

